<ng-container *transloco="let t; prefix: scope">
  <div class="flex min-h-[100svh] flex-col border-t-[10px] border-blg-yellow-500 bg-card font-sans text-bodytext">
    <div
      class="mx-auto flex w-full max-w-[1680px] flex-1 gap-10 px-[16px] py-[24px] sm:px-[24px] lg:px-[32px] lg:py-[32px]">
      <div class="flex min-w-0 flex-1 flex-col">
        <a
          routerLink="/login"
          queryParamsHandling="preserve"
          [attr.aria-label]="t('homeLink')"
          class="flex w-fit items-center gap-[12px] rounded-xl no-underline hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-focus">
          <img src="/assets/lundify-bear.svg" alt="" width="40" height="40" />
          <span class="font-['MaisonNeueBold',Poppins,sans-serif] text-[24px] text-headline">Lundify</span>
        </a>

        <main class="flex flex-1 items-center justify-center py-[48px]" aria-labelledby="sso-login-title">
          <div class="flex w-full max-w-[440px] flex-col gap-[32px] xlg:max-w-[600px] xl:max-w-[680px]">
            <div class="flex flex-col gap-[16px]">
              <h1
                id="sso-login-title"
                class="m-0 whitespace-pre-line font-['MaisonNeueBold',Poppins,sans-serif] text-[36px] font-normal leading-tight tracking-[-0.02em] text-headline sm:text-[48px] xl:text-[64px] xl:leading-[1.05]">
                {{ t('title') }}
              </h1>
              <p class="m-0 text-[18px] leading-normal text-description">{{ t('description') }}</p>
              <p class="m-0 whitespace-pre-line text-[18px] leading-normal text-description">
                {{ t('connectionDescription') }}
              </p>
              <a
                href="https://bjornlunden.com/se/redovisning/byralosning/"
                target="_blank"
                rel="noopener noreferrer"
                class="w-fit text-[16px] leading-normal text-link-primary underline underline-offset-2 hover:text-link-primary-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-focus">
                {{ t('aboutLogin') }}
                <span class="sr-only">{{ t('opensInNewTab') }}</span>
              </a>
            </div>

            <div class="flex flex-col gap-[12px] sm:flex-row sm:flex-wrap sm:items-center">
              <bl-frontend-button
                variant="primary"
                density="spacious"
                [text]="t('continueToLogin')"
                [trailingIcon]="{ name: 'arrow-right' }"
                [fullWidth]="true"
                class="block sm:w-auto"
                (onclick)="onContinueToLogin()">
              </bl-frontend-button>
              <bl-frontend-button
                variant="tonal"
                density="spacious"
                [text]="t('createAccount')"
                [fullWidth]="true"
                class="block sm:w-auto"
                (onclick)="onCreateAccount()">
              </bl-frontend-button>
            </div>
            @if (showLegacyLoginTestLink) {
              <a
                routerLink="/login"
                [queryParams]="{ sso: false }"
                class="w-fit text-sm leading-normal text-description underline underline-offset-2 hover:text-link-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-focus">
                {{ t('legacyLoginForTesting') }}
              </a>
            }
          </div>
        </main>
      </div>

      <aside class="flex w-1/2 shrink-0 items-center max-lg:hidden" aria-labelledby="sso-login-steps-title">
        <section
          class="sso-login-hero relative isolate h-full max-h-[880px] min-h-[600px] w-full overflow-hidden rounded-[32px] bg-cover bg-center">
          <video
            autoplay
            [muted]="true"
            loop
            playsinline
            preload="none"
            poster="/assets/auth-hero-grass-poster.jpg"
            aria-hidden="true"
            class="absolute inset-0 h-full w-full object-cover motion-reduce:hidden">
            <source
              src="/assets/auth-hero-grass-pingpong.mp4"
              type="video/mp4"
              media="(min-width: 992px) and (prefers-reduced-motion: no-preference)" />
          </video>
          <div
            aria-hidden="true"
            class="absolute inset-0 bg-gradient-to-b from-[#20202066] from-0% via-[#20202066] via-30% to-transparent to-60%"></div>

          <div class="relative px-[40px] pt-[56px] text-white xlg:px-[64px] xlg:pt-[80px]" aria-hidden="true">
            <p
              class="sso-login-tagline m-0 text-[48px] leading-[1.05] tracking-[-0.025em] xlg:text-[60px] xl:text-[80px]">
              {{ t('builtForCalm') }}
              <span class="mt-[0.15em] block text-[0.7em] [font-family:inherit]">{{ t('readyForGrowth') }}</span>
            </p>
          </div>

          <div class="absolute inset-x-[40px] bottom-[40px] max-w-[640px] xlg:inset-x-[64px] xlg:bottom-[64px]">
            <div class="rounded-[24px] bg-card p-[24px] shadow-2xl xl:p-[32px]">
              <h2
                id="sso-login-steps-title"
                class="m-0 mb-[16px] font-['MaisonNeueBold',Poppins,sans-serif] text-[24px] font-normal leading-tight text-headline">
                {{ t('oneTimeOnly') }}
              </h2>
              <ul class="m-0 flex list-none flex-col gap-[4px] p-0">
                @for (step of ['signInStep', 'connectAccountStep', 'readyStep']; track step) {
                  <li class="flex items-center gap-[12px] py-[8px]">
                    <span
                      aria-hidden="true"
                      class="flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-full bg-success-mid-3 text-white">
                      <bl-frontend-icon name="check"></bl-frontend-icon>
                    </span>
                    <span class="text-[16px] leading-normal text-bodytext">{{ t(step) }}</span>
                  </li>
                }
              </ul>
            </div>
          </div>
        </section>
      </aside>
    </div>
  </div>
</ng-container>
